export const VisiblePartnerDetailItems = [
  'name',
  'address',
  'postcode',
  'city'
];
